<div class="flex flex-col content pt-20 pr-26 pb-20 pl-26">
    <div class="flex flex-col w-100-percent">
    <div class="flex flex-row justify-between w-100-percent">
        <h1 class="flex flex-wrap mat-headline-5 mb-8 fw-600 fs-24 mr-98">{{value?.name | titlecase}}</h1>
        <mat-icon svgIcon="close" class="flex justify-end cursor-pointer icon-lg" [matDialogClose]="false"></mat-icon>
    </div>
    <div class="flex flex-row w-100-percent">
        <span class="flex flex-wrap mat-headline-5 mb-8 fw-400 fs-14 mr-98">{{'SCHEDULE.ENVIRONMENT' | transloco }}&nbsp;{{instance?.name ? instance?.name : '-'}}</span>
    </div>
    </div>
    <mat-divider class="neutral-blue-7 w-100-percent mb-8"></mat-divider>
    <div class="flex flex-col environment_header mb-8">
        <div class="flex flex-row">
        <div class="basis-full heading fs-16 fw-700 mb-12">{{ 'SCHEDULE_DETAILS.DETAIL' | transloco }}</div>
        </div>
        <div class="grid grid-cols-12 gap-6 w-full mb-6">
        <div class="col-span-4 service-title">
            <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'SCHEDULE_DETAILS.SCHEDULE_NAME' | transloco | titlecase}}</div>
            <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ value?.name ? value?.name : '-' }}</div>
        </div>
        <div class="col-span-4 service-title">
            <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'SCHEDULE_DETAILS.DESCRIPTION' | transloco | titlecase}}</div>
            <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ value?.description ? value?.description : '-' }}</div>
        </div>
        </div>
    </div>
    <mat-divider class="neutral-blue-7 w-100-percent mt-4 mb-8"></mat-divider>
    <div class="flex flex-col environment_header mb-8">
        <div class="flex flex-row">
              <div class="basis-full heading fs-16 fw-700 mb-12">{{ 'SCHEDULE_DETAILS.OCCURRENCE' | transloco }}</div>
            </div>
            <div class="grid grid-cols-12 gap-6 w-full mb-6">
                <div class="col-span-4 service-title">
                    <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'TEST_RESULTS.TIMEZONE' | transloco | titlecase}}</div>
                    <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ 'UTC' }}</div>
                  </div>
              <div class="col-span-4 service-title">
                <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'SCHEDULE_DETAILS.STARTDATE' | transloco | titlecase}}</div>
                <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ value?.startTime ? (value?.startTime | date: 'MMM dd yyyy, HH:mm:ss' : 'UTC') : '-'}}</div>
              </div>
              <div class="col-span-4 service-title">
                <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'SCHEDULE_DETAILS.ENDDATE' | transloco | titlecase}}</div>
                <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ value?.endTime ? (value?.endTime |  date: 'MMM dd yyyy, HH:mm:ss' : 'UTC') : '-'}}</div>
              </div>              
            </div>
            <div class="grid grid-cols-12 gap-6 w-full mb-6">
              <div class="col-span-4 service-title">
                <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'SCHEDULE_DETAILS.CRON_EXP' | transloco | titlecase}}</div>
                <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ value?.cronExpression ? value?.cronExpression : '-' }}</div>
              </div>
            </div>
    </div>
    <mat-divider class="neutral-blue-7 w-100-percent mt-4 mb-8"></mat-divider>
    <div class="flex flex-col environment_header mb-8">
        <div class="flex flex-row">
        <div class="basis-full heading fs-16 fw-700 mb-12">{{ 'RUNBOOK.RUNBOOK' | transloco }}</div>
        </div>
        <div class="grid grid-cols-12 gap-6 w-full mb-6">
        <div class="col-span-4 service-title">
            <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'SCHEDULE.RUNBOOK' | transloco | titlecase}}</div>
            <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ runbook?.name ? runbook?.name : '-' }}</div>
        </div>
        <div class="col-span-4 service-title">
            <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'RUNBOOK.OPERATION' | transloco | titlecase}}</div>
            <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ runbook?.componentName ? runbook?.componentName : '-' }}</div>
        </div>
        <div class="col-span-4 service-title">
            <div class="overline-font subheading fs-14 fw-700 mb-8">{{ 'SCHEDULE.VERSION' | transloco | titlecase}}</div>
            <div class="mat-subtitle-2 blueprint-value fw-400 fs-16 word-break-word">{{ runbook?.componentVersion ? runbook?.componentVersion : '-' }}</div>
        </div>
        </div>
    </div>
</div>
